// The API: the live server in a production build, the local one while
// developing. REACT_APP_API_URL overrides both.
const LIVE_API = "https://sekyererbapis.cbxapps.com";
const LOCAL_API = "http://localhost:5001";

export const Link =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? LIVE_API : LOCAL_API);
